module.exports = __webpack_public_path__ + "e4a7f8d9429414e278456100b900fa78.webp";